import React from 'react';

import { Main } from './components';

export const PortfolioCompanyUnderwritingPackagePage: React.FC = () => {
  return <Main />;
};
